import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { AppVersion } from '@shared/models/version.t';
import { environment } from '@environments/environment';

/**
 * Provides the deployed app version, baked into the build by CI
 * (`environment.version` / `environment.versionDate`). Returns `null` when unset.
 * No network call — the previous live `/api/version/` (Amsys) lookup was removed
 * because the QA/corp containers cannot reach the Amsys host.
 */
@Injectable({
  providedIn: 'root',
})
export class VersionService {
  getAppVersion(): Observable<AppVersion | null> {
    const version = environment.version.trim();
    if (!version) {
      return of(null);
    }
    return of({ version, merged_at: environment.versionDate.trim() || null });
  }
}
